{
  "app": {
    "name": "Cadence",
    "tagline": "Administrare școală de dans"
  },
  "nav": {
    "dashboard": "Panou",
    "students": "Cursanți",
    "teachers": "Profesori",
    "families": "Familii",
    "classes": "Clase",
    "events": "Evenimente",
    "mailing": "Mesaje",
    "media": "Media",
    "accounting": "Contabilitate",
    "reporting": "Rapoarte",
    "audit": "Jurnal audit",
    "settings": "Setări"
  },
  "break": {
    "notice": "Perioadă de pauză",
    "body": "Cursurile sunt suspendate luna aceasta, iar unele taxe pot fi reduse sau anulate."
  },
  "audit": {
    "title": "Jurnal audit",
    "lede": "O evidență needitabilă a acțiunilor importante din sistem — cine ce a făcut și când.",
    "system": "Sistem",
    "clear": "Șterge filtrele",
    "allActions": "Toate acțiunile",
    "allEntities": "Toate tipurile",
    "allUsers": "Toți utilizatorii",
    "searchPlaceholder": "Caută acțiune, entitate, detalii, IP, utilizator…",
    "prev": "Înapoi",
    "next": "Înainte",
    "showing": "Se afișează {from}–{to} din {total}",
    "empty": "Nicio înregistrare în jurnal",
    "emptyFiltered": "Nicio înregistrare nu corespunde filtrelor.",
    "detailTitle": "Înregistrare audit",
    "details": "Detalii",
    "userAgent": "Agent utilizator",
    "filters": {
      "search": "Căutare",
      "action": "Acțiune",
      "entity": "Tip entitate",
      "user": "Utilizator",
      "from": "De la",
      "to": "Până la"
    },
    "col": {
      "when": "Când",
      "actor": "Cine",
      "action": "Acțiune",
      "entity": "Entitate",
      "ip": "IP"
    }
  },
  "portalNav": {
    "dashboard": "Acasă",
    "classes": "Cursurile mele",
    "levels": "Nivelurile mele",
    "payments": "Plăți",
    "events": "Evenimente",
    "calendar": "Calendar",
    "gallery": "Galerie",
    "profile": "Profil",
    "contract": "Termeni"
  },
  "calendar": {
    "title": "Abonează-te la calendar",
    "lede": "Adaugă cursurile, evenimentele și scadențele de plată în propria aplicație de calendar. Fluxul se actualizează automat — te abonezi o dată și rămâne sincronizat.",
    "feedUrl": "Fluxul tău privat de calendar",
    "copy": "Copiază adresa",
    "copied": "Adresa calendarului a fost copiată",
    "copyFailed": "Nu s-a putut copia — selectează și copiază adresa manual",
    "subscribe": "Abonează-te",
    "readOnlyNote": "Acest link este privat și doar pentru citire. Oricine îl are îți poate vedea programul, așa că nu îl distribui.",
    "disabledHeading": "Calendarul este dezactivat",
    "disabledMessage": "Funcția de calendar nu este disponibilă momentan. Revino mai târziu sau întreabă școala.",
    "google": "Google Calendar",
    "googleStep1": "Deschide Google Calendar în browser.",
    "googleStep2": "Lângă „Alte calendare”, apasă + apoi „De la URL”.",
    "googleStep3": "Lipește adresa fluxului de mai sus și apasă „Adaugă calendar”.",
    "openGoogle": "Adaugă în Google Calendar",
    "apple": "Apple Calendar",
    "appleStep1": "În Calendar, alege Fișier → Abonament nou la calendar.",
    "appleStep2": "Lipește adresa fluxului de mai sus și apasă Abonează-te.",
    "appleStep3": "Alege un interval de actualizare și apasă OK.",
    "outlook": "Outlook",
    "outlookStep1": "În Outlook, mergi la Adaugă calendar → Abonare din web.",
    "outlookStep2": "Lipește adresa fluxului de mai sus.",
    "outlookStep3": "Denumește calendarul și apasă Importă."
  },
  "search": {
    "placeholder": "Caută cursanți…",
    "noResults": "Niciun rezultat"
  },
  "actions": {
    "save": "Salvează",
    "cancel": "Anulează",
    "logout": "Deconectare",
    "toggleTheme": "Comută tema",
    "collapseSidebar": "Restrânge meniul",
    "openMenu": "Deschide meniul",
    "continue": "Continuă",
    "back": "Înapoi"
  },
  "states": {
    "loading": "Se încarcă…",
    "empty": "Încă nimic aici"
  },
  "header": {
    "userMenu": "Meniu utilizator",
    "notifications": "Notificări",
    "language": "Limbă"
  },
  "a11y": {
    "primaryNav": "Principal",
    "portalNav": "Portal"
  },
  "cookies": {
    "title": "Cookie-uri",
    "body": "Folosim doar cookie-urile strict necesare pentru a-ți menține sesiunea și a face site-ul să funcționeze. Fără urmărire, analiză sau publicitate.",
    "learnMore": "Ce cookie-uri?",
    "hide": "Ascunde detaliile",
    "itemSession": "Cookie-uri de sesiune — te mențin autentificat în zonele de administrare și cursanți.",
    "itemPrefs": "Preferințe — limba și tema deschis/întunecat (stocate pe acest dispozitiv).",
    "itemNoTracking": "Nu folosim cookie-uri terțe, de urmărire, analiză sau publicitate.",
    "accept": "Am înțeles"
  },
  "title": {
    "admin": "Administrare",
    "portal": "Portal cursanți"
  },
  "notifications": {
    "title": "Notificări",
    "empty": "Nicio notificare încă",
    "markAllRead": "Marchează toate ca citite",
    "unread": "{count} necitite"
  },
  "onboarding": {
    "welcome": "Bun venit la {school}",
    "subtitle": "Hai să-ți configurăm contul în câțiva pași rapizi.",
    "stepContract": "Termeni",
    "stepPassword": "Parolă",
    "stepProfile": "Profil",
    "agree": "Am citit și sunt de acord cu termenii și condițiile de mai sus",
    "noContract": "Nu au fost publicați încă termeni. Te rugăm să contactezi școala.",
    "passwordHint": "Folosește cel puțin 8 caractere.",
    "password": "Parolă",
    "confirmPassword": "Confirmă parola",
    "mismatch": "Parolele nu coincid",
    "weak": "Parola trebuie să aibă cel puțin 8 caractere",
    "finish": "Finalizează",
    "completed": "Gata! Te ducem în portalul tău…",
    "invalid": "Acest link de configurare este invalid sau a fost deja folosit."
  },
  "portal": {
    "welcome": "Bine ai revenit, {name}",
    "upcomingClasses": "Cursuri viitoare",
    "payments": "Plăți restante",
    "paymentsEmpty": "Ești la zi cu plățile.",
    "levels": "Nivelurile mele",
    "events": "Evenimente viitoare",
    "eventsEmpty": "Niciun eveniment programat.",
    "quickLinks": "Linkuri rapide",
    "noClasses": "Nu ești înscris încă la niciun curs.",
    "noLevels": "Niciun nivel atribuit încă.",
    "willAttend": "Particip",
    "wontAttend": "Nu pot participa",
    "attending": "Particip",
    "notAttending": "Nu particip",
    "absent": "Marcat absent",
    "profileTitle": "Profilul meu",
    "bio": "Despre mine",
    "bioPlaceholder": "Spune-ne câteva cuvinte despre tine…",
    "saveBio": "Salvează",
    "contractTitle": "Termeni și condiții",
    "acceptedOn": "Acceptat pe {date} (versiunea {version})",
    "noContract": "Nu ai acceptat încă niciun set de termeni."
  },
  "errors": {
    "generic": "Ceva nu a mers. Te rugăm să încerci din nou.",
    "notFound": "Pagina nu a fost găsită",
    "notFoundBody": "Pagina pe care o cauți nu există."
  }
}
